<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <template #activator="{ on: onDialog, attrs: attrsDialog }">
      <v-tooltip bottom>
        <template #activator="{ on: onTooltip, attrs: attrsTooltip }">
          <v-icon
            class="mr-3"
            v-bind="{ ...attrsDialog, ...attrsTooltip }"
            v-on="{ ...onDialog, ...onTooltip }"
          >
            mdi-delete
          </v-icon>
        </template>
        <span>löschen</span>
      </v-tooltip>
    </template>
    <form @submit.prevent="save">
      <v-card>
        <v-toolbar flat>
          <v-toolbar-title>Löschen bestätigen</v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          Bitte gib den Grund für das Löschen ein.
        </v-card-text>
        <v-card-text>
          <v-text-field
            v-model="form.reason"
            name="reason"
            label="Begründung"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="cancel">
            Abbrechen
          </v-btn>
          <v-btn :loading="form.processing" color="primary" type="submit">
            Löschen
          </v-btn>
        </v-card-actions>
      </v-card>
    </form>
  </v-dialog>
</template>

<script>
export default {
   components: {
      //
   },

   props: {
      offer: {
         type: Object,
         required: true
      },
   },

   data () {
      return {
         dialog: false,
         form: this.$inertia.form({
            reason: ''
         }),
      }
   },

   methods: {
      cancel () {
         this.dialog = false
      },

      save () {
         this.form.delete(this.route('offer.destroy', [this.offer.id]), {
            preserveScroll: true,
            preserveState: true,
         }).then(() => {
            this.dialog = null
         })
      },
   }
}
</script>
